import svgToImage from '../../../helpers/svgToImage';
import { isDataURL } from '../../../helpers/dataUrl';
import Facade from './facade';
import humps from '../../utils/humps';
import ImagesFactory from '../../factory/images';
import { deleteVideoPlayer } from '../../video';
import { PageToImageFactory } from 'src/factories/page-to-image';
function DesignFacade () { }

DesignFacade.prototype = new Facade();
DesignFacade.prototype.constructor = DesignFacade;

DesignFacade.prototype.initialize = function () {
  Facade.prototype.initialize.call(this);
  _.bindAll(this, 'set', 'get', 'create', 'preview');
};

DesignFacade.prototype.preview = function (id, params) {
  let element;
  id = id || 'full';

  params = params || {};
  const svgcontent = document.getElementById('svgcontent').cloneNode(true);
  const data = id === 'full' ? getFullCanvasData.call(this) : this.get(id);

  switch (id) {
    case 'full':
      element = svgcontent.querySelector('.main');
      break;

    case 'background':
      element = [...svgcontent.querySelectorAll('g.background > :not(title)')].pop();
      break;

    default:
      element = document.getElementById(id);
  }

  if (!element || !data) {
    this.propagate('exception', id, null, 'Element not found');
    return;
  }

  const ratio = data.size.width / data.size.height;
  const maxWidth = params.maxwidth || data.size.width;
  const maxHeight = params.maxheight || data.size.height;
  const height = ratio * maxHeight > maxWidth ? maxWidth / ratio : maxHeight;
  const width = ratio * height;
  const svgXml = `
    <svg
      xmlns="http://www.w3.org/2000/svg" xlinkns="http://www.w3.org/1999/xlink"
      viewBox="${data.position.x}, ${data.position.y}, ${data.size.width}, ${data.size.height}"
      x="0"
      y="0"
      width="${width}"
      height="${height}"
    >
      ${params.background
      ? `<rect
            fill="${params.background}"
            x="${data.position.x}"
            y="${data.position.y}"
            width="${data.size.width}"
            height="${data.size.height}"
          ></rect>`
      : ''
    }
      ${INKIVE.Helpers.serializeToString(element)}
    </svg>
  `;
  const svgString = id === 'full'
    ? INKIVE.EditorFacade.editor.getSvgString()
    : this.canvas.svgCanvasToString($(svgXml)[0]);

  try {
    const outputFormat = 'image/' + (params.format || (params.background ? 'jpeg' : 'png'));
    const quality = outputFormat === 'jpg' ? params.quality || 0.6 : null;
    const pageId = INKIVE.Tool._current_design_id;

    const pageToImageFactory = new PageToImageFactory();
    pageToImageFactory.getImageDataUrlFromContent(svgString).then((url) => {
      if (pageId === INKIVE.Tool._current_design_id && url) {
        this.propagate('preview', params.isdownload ? 'download' : id, null, url);
      }
    });
  } catch (e) {
    console.error(e);
    this.propagate('exception', id, null, e);
  }

  function getFullCanvasData () {
    return {
      size: {
        width: this.canvas.getResolution().w,
        height: this.canvas.getResolution().h
      },
      position: {
        x: 0,
        y: 0
      }
    };
  }
};

DesignFacade.prototype.delete = function (id, data) {
  this.trigger('predelete', id);
  if (this.preSelect(id)) {
    _.each(this.canvas.getSelectedElems(), function (element) {
      const funcName = humps.camelize('delete_' + this.getType(element));
      this[funcName] && this[funcName](element, data);
    }, this);

    this.canvas.deleteSelectedElements();
    this.trigger('delete', id, data);
  }
};

DesignFacade.prototype.deleteMultiple = function (data) {
  const selectedElements = [...this.canvas.getSelectedElems()];
  const selectedIds = selectedElements.map(element => element.id);

  selectedElements.forEach(element => {
    const funcName = humps.camelize('delete_' + this.getType(element));
    this[funcName] && this[funcName](element, data);
  });

  this.canvas.deleteSelectedElements();

  selectedIds.forEach(id => this.trigger('delete', id));
};

DesignFacade.prototype.deleteImage = function (element) {
  const url = element.getAttribute('xlink:href');
  const originalUrl = ImagesFactory.getImageUrl(element);

  if (element.classList.contains('quick-delete')) {
    removePlaceholder();
  }

  if (!originalUrl && isDataURL(url)) {
    ImagesFactory.blacklistImage(element);
  }

  function removePlaceholder () {
    element.classList.remove('quick-delete');
    element.classList.remove('layoutBox');
  }
};

DesignFacade.prototype.deleteVideo = function (element) {
  element.remove();
  deleteVideoPlayer(element);
};

DesignFacade.prototype.deleteBackground = function (element, type) {
  const $backgroundElement = $('#svgcontent').find('g.background');
  const elem = $backgroundElement.find($(element).is('image') ? 'image' : 'rect');
  this.canvas.selectOnly(elem);
  this.canvas.deleteSelectedElements();
};

DesignFacade.prototype.duplicate = function (id) {
  const elements = this.canvas.cloneSelectedElements(20, 20);
  this.trigger('duplicate', id, elements);
};

DesignFacade.prototype.sendForward = function () {
  this.canvas.moveUpDownSelected('Up');
  this.trigger('send_forward');
};

DesignFacade.prototype.sendBackward = function () {
  this.canvas.moveUpDownSelected('Down');
  this.trigger('send_backward');
};

DesignFacade.prototype.sendTop = function () {
  this.canvas.moveToTopSelectedElement();
  this.trigger('send_top');
};

DesignFacade.prototype.sendBottom = function () {
  this.canvas.moveToBottomSelectedElement();
  this.trigger('send_bottom');
};

DesignFacade.prototype.preSelect = function (id, showGrips) {
  if (id) {
    const element = id === 'background'
      ? $('#svgcontent').children('g.background').children(':not(title)').last()[0]
      : $('#' + id)[0];

    if (!element) return false;
    this.canvas.selectOnly([element], showGrips);
  }

  return this.canvas.getSelectedElems().length > 0;
};

DesignFacade.prototype.getSelectedElements = function (type) {
  const selectedElements = this.canvas.getSelectedElems();

  return type
    ? selectedElements.filter(elem => this.getType(elem) === type)
    : selectedElements;
};

const instance = new DesignFacade();
module.exports = instance;
export default instance;
